<template>
    <div class="modal text-left" id="company_detail_modal_update" tabindex="-1" role="dialog" aria-labelledby="myModalLabel334" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel334">Company Details</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" ref="closeModel">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <form >
                    <div class="modal-body ">
                        <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-6 col-12 mb-1">
                                <div class="form-group">
                                    <label class="label-green" for="business_logo">
                                        Click or Drag & Drop an Image to Upload your Logo
                                        <br>
                                        <div class="badge badge-info">
                                            <i data-feather="image" class="mr-25"></i>
                                            <span>
                                                {{ localizationStore.translate('dimension_400_400') }}
                                            </span>
                                        </div>
                                    </label>
                                    <div class="image-drop-zone mt-1"
                                        @dragover.prevent
                                        @drop="onImageDrop" v-on:click="openInputUpload">
                                        <img v-if="file" :src="file" alt="Dropped Image">
                                        <p style="text-align: center;padding:14px;font-weight: bold;" v-else>Click To Add an Image Drag and Drop</p>
                                    </div>
                                    <div class="custom-file" hidden>
                                        <input type="file" class="custom-file-input" id="business_logo"  @change="selectedImg" ref="uploadImage"/>
                                        <label class="custom-file-label label-green" for="business_logo">Choose Logo</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label-green" for="business_name">
                                        Company Name
                                        <div class="badge badge-info">
                                            <span>
                                                {{ localizationStore.translate('company.name.guide.message') }}
                                            </span>
                                        </div>
                                    </label>
                                    <input type="text" class="form-control to-lower-case" name="business_name" id="business_name" placeholder="Company Name..." v-model="businessName"/>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label class="label-green">Company Url</label>
                                        <div class="input-group">
                                            <input id="company-url" type="text" class="form-control" v-model="clientLoginUrl" readonly ref="urlinput"/>
                                            <div class="input-group-append">
                                                <button
                                                    class="btn btn-outline-primary"
                                                    data-clipboard-target="#company-url"
                                                    type="button"
                                                    data-toggle="tooltip"
                                                    data-placement="top"
                                                    :title="tooltipData"
                                                    @click="copyUrl"
                                                >
                                                    <i data-feather="copy"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label class="label-green" for="company_address">Company Address</label>
                                        <input type="text" class="form-control"
                                            placeholder="Address" id="company_address" name="company_address"
                                            data-validation-required-message="This company_address field is required" v-model="company_address">

                                    </div>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label class="label-green" for="company_city">Company City</label>
                                        <input type="text" class="form-control" placeholder="Company City"
                                            id="company_city" name="company_city" data-validation-required-message="This company_city field is required" v-model="company_city">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label-green" for="state">Company State</label>
                                    <select class="form-control"  placeholder="Company State"
                                        id="company_state" name="company_state" data-validation-required-message="This company city field is required" v-model="company_state">
                                            <option v-for="(state,index) in states">
                                                {{ state.name }}
                                            </option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label class="label-green" for="company_zipcode">Company Zipcode</label>
                                        <input type="text" class="form-control"
                                            placeholder="Company Zipcode" id="company_zipcode" name="company_zipcode"
                                            maxlength="5"
                                            v-model="company_zipcode"
                                            data-validation-required-message="This company zipcode field is required">

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 col-lg-6 col-sm-12">
                                <div class="form-group">
                                    <label class="label-green" for="company_email">Company Email</label>
                                    <input type="text" class="form-control" id="company_email" name="company_email"
                                        v-model="company_email" />
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-sm-12" >
                                <div class="form-group">
                                    <div class="controls">
                                        <label class="label-green" for="company_phone">Company Phone</label>
                                        <phone-input-component name="company_phone" :prop-phone="company_phone" @phoneInput="updateCompanyPhone"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- add service fee under consultation fee -->
                        <div class="row">
                            <div class="col-md-6 col-lg-6 col-sm-12">
                                <div class="form-group">
                                    <div class="controls">
                                        <label class="label-green" for="consultation_fee">
                                            {{localizationStore.translate('company.detail.consultation.fee')}}
                                        </label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">$</span>
                                            </div>
                                            <input
                                                type="number"
                                                class="form-control"
                                                :placeholder="localizationStore.translate('company.detail.consultation.fee.placeholder')"
                                                id="consultation_fee"
                                                name="consultation_fee"
                                                data-toggle="popover"
                                                :data-content="localizationStore.translate('contract.setting.popover.message')"
                                                data-trigger="hover"
                                                :data-original-title="`<span class='feather-icon d-flex align-items-center'>${localizationStore.translate('contract.setting.popover.title')}</span>`"
                                                data-placement="top"
                                                data-html="true"
                                                v-model="consultation_fee"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 col-lg-6 col-sm-12">
                                <div class="form-group">
                                    <div class="controls">
                                        <label class="label-green" for="consultation_fee">
                                            {{localizationStore.translate('company.detail.service.fee')}}
                                        </label>
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">$</span>
                                            </div>
                                            <input
                                                type="number"
                                                class="form-control"
                                                :placeholder="localizationStore.translate('company.detail.service.fee.placeholder')"
                                                id="consultation_fee"
                                                name="consultation_fee"
                                                data-toggle="popover"
                                                :data-content="localizationStore.translate('service.setting.popover.message')"
                                                data-trigger="hover"
                                                :data-original-title="`<span class='feather-icon d-flex align-items-center'>${localizationStore.translate('service.setting.popover.title')}</span>`"
                                                data-placement="top"
                                                data-html="true"
                                                v-model="service_fee"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-lg-12 col-sm-12">
                                <div class="form-group">
                                    <label class="label-green" for="company_email">Service Agreement</label>
                                    <p>Your clients will sign this prior to accessing their Client portal. Update the text contents below or Simply use our Default Credit Service Agreement.</p>
                                    <label class="label-green">Select Custom Tags To add to service agreement</label>
                                    <div class="d-flex justify-content-between">
                                        <Select2
                                            id="blog-edit-category"
                                            class="col-sm-4"
                                            v-model="customValue"
                                            :options="customValueOptions"
                                            placeholder="custom values"
                                            @select="addCustomCode"
                                            style="padding-left: 0px !important;"
                                        />
                                        <button type="button"  class="btn btn-outline-primary mr-sm-1" @click="resetServiceAgreement">Reset To Default</button>
                                    </div>

                                    <br/>

                                    <input type="hidden" name="editor" :value="service_agreement">
                                    <editor
                                        :id="key"
                                        v-model="service_agreement"
                                        :api-key="settingStore.tinymce.api_key"
                                        ref="editor"
                                        :init="settingStore.tinymce.configuration"
                                        @init="onEditorInit"
                                    />
                                </div>
                            </div>
                            <div ref="agreementRef" hidden>
                                <service-agreement-model/>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <div class="col-12 d-flex flex-sm-row flex-column justify-content-center">
                            <button type="button"  class="btn btn-primary mr-sm-1 mb-1 mb-sm-0" @click="saveSettings($e)" :key="keyValue">{{isSavingInfo}}</button>
                            <button type="button" data-dismiss="modal" class="btn btn-outline-primary">Close</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="modal show text-left" tabindex="-1" role="dialog" aria-labelledby="myModalLabel334" aria-hidden="true" v-if="showCropperModel" style="display:block;">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="myModalLabel334">Click or Drag & Drop an Image to Upload your Logo</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body " v-if="showCropperModel">
                    <div class="image_container">
                        <cropper
                            v-if='img'
                            class="cropper"
                            :src="img"
                            :stencil-props="{
                                aspectRatio: 1 / 1,
                                movable: true,
                                resizable: false,
                                toggleDragModeOnDblclick: false,
                                cropBoxResizable: false,
                            }"
                            @change="change"
                            ref="cropper"
                        />
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="col-12 d-flex flex-sm-row flex-column justify-content-center">
                        <button type="button"  class="btn btn-primary mr-sm-1 mb-1 mb-sm-0" @click.once="saveCroppedImage($e)" :key="keySaves">Save</button>
                        <button type="button" data-dismiss="modal" class="btn btn-outline-primary" v-on:click="showCropper">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, reactive } from 'vue'
import { useUserStore } from '../../../../stores/UserStore.js'
import { useBusinessStore } from '../../../../stores/BusinessStore.js'
import { useLocalizationStore } from '../../../../stores/LocalizationStore.js'
import { useSettingStore } from '../../../../stores/SettingStore.js'
import { Cropper } from 'vue-advanced-cropper'
import ServiceAgreementModel from './Settings/ServiceAgreementModel.vue'
import Editor from '@tinymce/tinymce-vue'
import {isNotNullorUndefined} from '../../../../utilities/_helpers.js'
import Select2 from 'vue3-select2-component'

import axios from 'axios'
export default{
    name:'CompanyDetailModel',
    components:{
        Cropper,
        ServiceAgreementModel,
        Editor,
        Select2
    },
    data(){
        return{
            service_agreement:""
        }
    },
    setup(){
        const businessName = ref(),
        clientLoginUrl = ref(),
        company_address = ref(),
        company_city = ref(),
        company_state = ref(),
        company_zipcode = ref(),
        company_email = ref(),
        company_phone = ref(null),
        businessLogo = ref(),
        states = ref(),
        img = ref(),
        cropper = ref(),
        file = ref(),
        key = "service_key",
        keyValue = ref(0),
        urlinput = ref(),
        tooltipData = ref('Copy To Clipboard');
        const userStore = useUserStore(),
        BusinessStore = useBusinessStore(),
        localizationStore = useLocalizationStore(),
        showCropperModel=ref(false),
        keySaves = ref(0),
        fileSrc = ref(null),
        service_fee =ref(null),
        originalFile = ref(null),
        croppedCoordinates = reactive({}),
        consultation_fee = ref(),
        customValue = ref(null),
        customValueOptions =['companyName','company_address','company_city','company_state','company_zipcode','firstName','lastName','address','city','state','zipCode','today','consultation_fee','service_fee','customValue'],
        agreementRef = ref(null),
        isSavingInfo = ref('Save');
        return{
            userStore,
            BusinessStore,
            localizationStore,
            businessName,
            clientLoginUrl,
            company_address,
            company_city,
            company_state,
            company_zipcode,
            company_email,
            originalFile,
            croppedCoordinates,
            key,
            customValueOptions,
            customValue,
            isSavingInfo,
            company_phone,
            businessLogo,
            states,
            img,
            file,
            cropper,
            keyValue,
            urlinput,
            tooltipData,
            showCropperModel,
            fileSrc,
            keySaves,
            consultation_fee,
            service_fee,
            agreementRef,
            settingStore: useSettingStore(),
        }
    },
    watch: {
        async 'BusinessStore.business' (value) {
            this.businessName = isNotNullorUndefined(value.businessName) ? value.businessName : null
            this.clientLoginUrl = isNotNullorUndefined(value.clientLoginUrl) ? value.clientLoginUrl : null
            this.company_address = isNotNullorUndefined(value.settings.company_address) ? value.settings.company_address : null
            this.company_city = isNotNullorUndefined(value.settings.company_city) ? value.settings.company_city : null
            this.company_state = isNotNullorUndefined(value.settings.company_state) ? value.settings.company_state : null
            this.company_zipcode = isNotNullorUndefined(value.settings.company_zipcode) ? value.settings.company_zipcode : null
            this.company_email = isNotNullorUndefined(value.settings.company_email) ? value.settings.company_email : null
            this.company_phone = !_.isNull(value.settings.company_phone) ? value.settings.company_phone : null
            this.consultation_fee = isNotNullorUndefined(value.settings.consultation_fee) ? value.settings.consultation_fee : null
            this.service_fee = isNotNullorUndefined(value.settings.service_fee) ? value.settings.service_fee : null
            this.file = isNotNullorUndefined(value.businessLogo) ? '/'+value.businessLogo : null
            this.states = isNotNullorUndefined(value.states) ? value.states : null
        },
        async 'BusinessStore.clickedBusinessDetails' (value) {
             if(value == true){
                let $this = this;
                const businessStore = $this.BusinessStore.business;
                if (isNotNullorUndefined(businessStore.settings) ) {
                    if(isNotNullorUndefined(businessStore.settings.service_agreement)){
                        $this.service_agreement = businessStore.settings.service_agreement;
                    }else {
                        $this.service_agreement = $this.agreementRef && $this.agreementRef.innerHTML;
                    }
                }
             }
        },
    },
    mounted() {
        const $this = this;
        document.onreadystatechange = () => {
            if (document.readyState == "complete") {
                setTimeout(() => {
                    $this.$nextTick().then(() => {
                        const businessStore = $this.BusinessStore.business;
                        if (isNotNullorUndefined(businessStore.settings) ) {
                            if(isNotNullorUndefined(businessStore.settings.service_agreement)){
                                $this.service_agreement = businessStore.settings.service_agreement;
                            }else {
                                $this.service_agreement = $this.agreementRef && $this.agreementRef.innerHTML;
                            }
                        }

                    });
                }, 3000);
            };
        }
    },
    updated(){
        const $this = this;
        document.onreadystatechange = () => {
            if (document.readyState == "complete") {
                setTimeout(() => {
                    $this.$nextTick().then(() => {
                        const businessStore = $this.BusinessStore.business;
                        if (isNotNullorUndefined(businessStore.settings) ) {
                            if(isNotNullorUndefined(businessStore.settings.service_agreement)){
                                $this.service_agreement = businessStore.settings.service_agreement;
                            }else {
                                $this.service_agreement = $this.agreementRef && $this.agreementRef.innerHTML;
                            }
                        }
                    });
                }, 3000);
            };
        }
    },
    methods:{
        resetServiceAgreement(){
            const $this = this;
            $this.service_agreement = $this.agreementRef && $this.agreementRef.innerHTML;

        },
        onEditorInit(editor){
            this.editor = editor;
        },
        addCustomCode() {
            this.service_agreement = `{{${this.customValue}}} <br />` + this.service_agreement
            this.customValue = ""
        },
        openInputUpload(){
           this.$refs.uploadImage.click()
        },
        saveCroppedImage(){
            this.img = this.file;
            this.showCropper();
            this.keySaves++;
        },
        showCropper(){
            this.showCropperModel = !this.showCropperModel;
        },
        onImageDrop (event) {
            event.preventDefault();
            const imageFile = event.dataTransfer.files[0];
            this.originalFile = imageFile
            const imageUrlObject = URL.createObjectURL(imageFile);
            this.img = imageUrlObject;
            this.showCropperModel = true;
        },
        converter(canvas){
            this.file = canvas.toDataURL();
        },
        change({ coordinates, canvas }) {
            this.croppedCoordinates = coordinates
            this.converter(canvas)
		},
        selectedImg(e) {
            e.preventDefault()
            const file = e.target.files[0];
            this.originalFile = file
            this.img = URL.createObjectURL(file);
            this.showCropper();
        },
        saveSettings(){
            this.isSavingInfo = 'Saving...'
            let coords = this.croppedCoordinates
            let test =  null
            const formData = new FormData();
            formData.append('business_name', isNotNullorUndefined(this.businessName) ?this.businessName : "" )
            formData.append('company_address', isNotNullorUndefined(this.company_address) ?this.company_address : "" )
            formData.append('company_city', isNotNullorUndefined(this.company_city) ?this.company_city : "" )
            formData.append('company_state', isNotNullorUndefined(this.company_state) ?this.company_state : "" )
            formData.append('company_zipcode', isNotNullorUndefined(this.company_zipcode) ?this.company_zipcode : "" )
            formData.append('company_email', isNotNullorUndefined(this.company_email) ?this.company_email : "" )
            formData.append('company_phone', isNotNullorUndefined(this.company_phone) ?this.company_phone : "" )
            formData.append('consultation_fee', isNotNullorUndefined(this.consultation_fee) ?this.consultation_fee : "" )
            formData.append('service_fee', isNotNullorUndefined(this.service_fee) ?this.service_fee : "" )
            formData.append('service_agreement', isNotNullorUndefined(this.service_agreement) ?this.service_agreement : "" )
            formData.append('business_logo', this.originalFile )
            formData.append('image_width', isNotNullorUndefined(coords.width) ?coords.width : "" )
            formData.append('image_height', isNotNullorUndefined(coords.height) ?coords.height : "" )
            formData.append('image_left', isNotNullorUndefined(coords.left) ?coords.left : "" )
            formData.append('image_top', isNotNullorUndefined(coords.top) ?coords.top : "" )
            const route = this.$router.resolve(
                {
                    name: 'company-store',
                }
            );
            const $this = this;
            axios.post(route.href,formData).then(({data})=>{
                if(data.error != true){
                    toastr.success(data.message,'Success')
                    $this.BusinessStore.fetchBusiness()
                    $this.keyValue++
                    $this.file = null
                    $this.$refs.closeModel.click()
                    this.isSavingInfo = 'Save'

                }else{
                    this.isSavingInfo = 'Save'

                    if(data.message){
                        toastr.error(data.message,'Error')
                    }
                    toastr.error('An error occured while updating your Company Settings please try again')
                }
            })

        },
        copyUrl(){
            this.$refs.urlinput.select()
            document.execCommand('copy');
            toastr.success('Company url copied!','copied');
            this.tooltipData = "Copied!"
        },
        updateCompanyPhone(phone) {
            this.company_phone = phone;
        },
    }
}
</script>
<style>
.image-drop-zone {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 200px;
  border: 1px dashed #ccc;
}
.select2-container--default .select2-selection--single .select2-selection__arrow b {
    border-width: 0px 4px 0 4px;
    height: 25px;
    left: 0%;
}
</style>
